import React from 'react';
import styled from 'styled-components';
import FooterCol from './FooterCol';
import PText from './PText';

const FooterStyle = styled.div`
  background-color: var(--deep-dark);
  padding-top: 10rem;
  .container {
    display: flex;
    gap: 3rem;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
    color: #e75480;
  }
  .copyright {
    background-color: var(--deep-dark);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      margin-left: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  return (
    <FooterStyle>
      <div className="container">
        <div className="footer__col1">
          <h1 className="footer__col1__title">
            Riccioli d'Oro di Laura M. & C. S.a.s.
          </h1>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Important Links"
            links={[
              {
                title: 'Home',
                path: '/',
                type: 'Link',
              },
              {
                type: 'Link',
                title: 'Chi sono',
                path: '/about',
              },
              {
                type: 'Link',
                title: 'LookBook',
                path: '/projects',
              },
              {
                type: 'Link',
                title: 'Contatti',
                path: '/contact',
              },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Contatti"
            links={[
              {
                title: '+39 0331 289717',
                path: 'tel:+39 0331 289717',
              },
              {
                title: 'montanari_laura@yahoo.it',
                path: 'mailto:montanari_laura@yahoo.it',
              },
              {
                title: 'Via Garibaldi 45, Cassano Magnago, 21012, (VA)',
                path:
                  'https://www.google.it/maps/place/Via+G.+Garibaldi,+45,+21012+Cassano+Magnago+VA/@45.6653569,8.8194096,17z/data=!3m1!4b1!4m5!3m4!1s0x478689a433e3ed83:0x3e1857192b3fbcfe!8m2!3d45.6653532!4d8.8215983?hl=it&authuser=0',
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="Social "
            links={[
              {
                title: 'Facebook',
                path: 'https://www.facebook.com/RICCIOLI-DORO-259299067442693',
              },

              {
                title: 'Instagram',
                path: 'https://www.instagram.com/riccioli_d_oro_laura/',
              },
            ]}
          />
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <PText>
            Design by{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="http://tarantiniconsulting.com"
            >
              Stefano Tarantini © 2021
            </a>{' '}
          </PText>
        </div>
      </div>
    </FooterStyle>
  );
}
